export enum EntityType {
  Institution = 1,
  PublicAgency = 2,
  Company = 3,
}
